import React from 'react'
import './title-template.css'

const TitleTemplatePure = ({title}) => {

  return (
    <div className="title-header" xs={12} lg={12} md={12} sm={12}>
      <h3 className="TitleTemplatePure-text-title">{title}</h3>
    </div>
    )
  }

export { TitleTemplatePure as default }
